import type { KolorWypowiedzi } from "@shared/koloryWypowiedzi.js";

/**
 * Jakosc wypowiedzi w transkrypcie: slowa i znaczenia, bez DOM.
 *
 * Wartosc pochodzi z shared/koloryWypowiedzi.ts (kolorWypowiedzi): wynika WYLACZNIE ze zweryfikowanych
 * wskazan przy wypowiedzi. "brak" nie jest jakoscia - wypowiedz bez wskazan zostaje bez koloru, a w legendzie
 * ma pozycje "bez wskazan". Nazwy tu sa tym, co widzi uzytkownik (kolor nigdy nie znaczy sam, A-7).
 */

export type JakoscWypowiedzi = Exclude<KolorWypowiedzi, "brak">;

/** Od najlepszej do najslabszej: tak czyta sie legenda. */
export const KOLEJNOSC_JAKOSCI: readonly JakoscWypowiedzi[] = ["najlepsze", "srednie", "najslabsze"];

export const ETYKIETY_JAKOSCI: Readonly<Record<JakoscWypowiedzi, string>> = {
  najlepsze: "najlepsze",
  srednie: "średnie",
  najslabsze: "najsłabsze",
};

/** Zdanie do legendy: po czym poznac, skad ten kolor. */
export const OPISY_JAKOSCI: Readonly<Record<JakoscWypowiedzi, string>> = {
  najlepsze: "same mocne strony",
  srednie: "mocne strony i rzeczy do poprawy",
  najslabsze: "same rzeczy do poprawy",
};

/**
 * Wariant plakietki jakosci: te same tokeny --ocena-* co tint dymka (decyzja autora metodyki z 29.10.2026). Najlepsze
 * sa zlote, najslabsze szare, a srednie zostaja bez oznaczenia: dymek bez tintu i plakietka neutralna (BD-2), ktora
 * niesie samo slowo, zeby srednia wypowiedz dalo sie odroznic od wypowiedzi bez wskazan (A-7).
 */
export const WARIANTY_JAKOSCI: Readonly<Record<JakoscWypowiedzi, "zloto" | "neutralny" | "szarosc">> = {
  najlepsze: "zloto",
  srednie: "neutralny",
  najslabsze: "szarosc",
};

/** Etykiety rodzaju wskazania w interfejsie. */
export const ETYKIETY_RODZAJU: Readonly<Record<"mocna-strona" | "do-poprawy", string>> = {
  "mocna-strona": "mocna strona",
  "do-poprawy": "do poprawy",
};
